import _ from 'lodash';
import $ from 'jquery';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';

const ActionTypes = Constants.ActionTypes;

const requestApi = function (data, path, full) {
  let url = _.get(globals, 'apiWebroot', '/') + path;
  // TODO šo aspektu vēl apskatīt
  if (full) {
      url = _.get(globals, 'webroot', '/') + path;
  }

  return $.ajax({
    type: 'GET',
    url,
    data,
    dataType: 'json',
  });
};

module.exports = {
  // Bloķēt lietotāju
  block(memberId) {
    const request = requestApi(null, `member/${memberId}/block`, true);

    // success
    request.done((data) => {
      // pievieno lietotāja datus
      if (
        !_.isEmpty(data.status) && data.status == 'ok'
					&&
					data.blocked
      ) {
        AppDispatcher.dispatch({
          type: ActionTypes.MEMBER_BLOCK,
          memberId,
          canAccess: data.can_access,
        });
      }
    });

    // fail
    request.fail((data) => {
      location.reload(true);
      // TODO vajadzētu izvadīt kļūdu paziņojumu
    });
  },
  // Atbloķēt lietotāju
  unblock(memberId) {
    const request = requestApi(null, `member/${memberId}/unblock`, true);

    // success
    request.done((data) => {
      // pievieno lietotāja datus
      if (
        !_.isEmpty(data.status) && data.status == 'ok'
					&&
					(typeof data.blocked === 'boolean') && !data.blocked
      ) {
        AppDispatcher.dispatch({
          type: ActionTypes.MEMBER_UNBLOCK,
          memberId,
          canAccess: data.can_access,
        });
      }
    });

    // fail
    request.fail((data) => {
      location.reload(true);
      // TODO vajadzētu izvadīt kļūdu paziņojumu
    });
  },
  // Ignorē lietotāju
  ignore(memberId) {
    const request = requestApi(null, `member/${memberId}/ignore`, true);

    // success
    request.done((data) => {

    });

    // fail
    request.fail((data) => {
      location.reload(true);
      // TODO vajadzētu izvadīt kļūdu paziņojumu
    });
  },
  // atceļ lietotāja ignorēšanu
  unignore(memberId) {
    const request = requestApi(null, `member/${memberId}/unignore`, true);

    // success
    request.done((data) => {

    });

    // fail
    request.fail((data) => {
      location.reload(true);
      // TODO vajadzētu izvadīt kļūdu paziņojumu
    });
  },
  // Sūtīt vai nesūtīt vēstules, ja nospiests Enter
  submitOnEnter(value) {
    // console.log(value);
    const request = requestApi({ value }, 'member/submit_on_enter');

    AppDispatcher.dispatch({
      type: ActionTypes.SUBMIT_ON_ENTER,
      value,
    });
  },
  loadLocalSearchedMembers() {
    if (typeof globals.searched_members_data === 'undefined') {
      return;
    }

    let page = 1;
    if (_.get(globals, 'searched_members_data.page', false)) {
      page = globals.searched_members_data.page;
    }

    AppDispatcher.dispatch({
      type: ActionTypes.SEARCHED_MEMBERS_LOAD_SUCCESS,
      members: globals.searched_members_data.members,
      page,
    });
  },
  // Pēdējie meklētie lietotāji
  loadSearchedMembers(page) {
    const requestData = {};
    if (page) {
      requestData.page = page;
    }
    const request = requestApi(requestData, 'member/searched_members');

    // success
    request.done((data) => {
      // pievieno lietotāja datus
      if (
        !_.isEmpty(data.status) && data.status == 'ok'
      ) {
        AppDispatcher.dispatch({
          type: ActionTypes.SEARCHED_MEMBERS_LOAD_SUCCESS,
          members: data.members,
          page: data.page,
        });
      }
    });
    // fail
    request.fail((data) => {
      AppDispatcher.dispatch({
        type: ActionTypes.SEARCHED_MEMBERS_LOAD_FAIL,
      });
    });
  },
  loadLocalFetchedMembers(member_ids) {
    if (typeof globals.fetched_members_data === 'undefined') {
      if (member_ids.length > 0) {
        try {
          this.loadFetchedMembers(1, member_ids, 'member/fetch_members');
        } catch (e) {

        }
      } else {
        this.loadFetchedMembers(1, null, `${window.location.pathname}.json`);
      }
    } else {
      AppDispatcher.dispatch({
        type: ActionTypes.MEMBERS_LOAD_SUCCESS,
        members: globals.fetched_members_data.members,
        page: globals.fetched_members_data.page,
      });
    }
  },
  loadFetchedMembers(page, member_ids, path, next_page = false, full = false) {
    if (typeof path === 'undefined') {
      path = 'member/searched_members';
    }

    const self = this;

    const requestData = {};
    if (member_ids) {
      requestData.member_ids = member_ids;
    }
    if (page) {
      requestData.page = page;
    }
    const request = requestApi(requestData, path, full);

    // success
    request.done((data) => {
      // pievieno lietotāja datus
      if (
        !_.isEmpty(data.status) && data.status == 'ok'
      ) {
        if (next_page == false) {
          AppDispatcher.dispatch({
            type: ActionTypes.MEMBERS_FETCH_SUCCESS,
            members: data.members,
            page: data.page,
          });

          self.loadFetchedMembers(page + 1, null, path, true);
        } else {
          AppDispatcher.dispatch({
            type: ActionTypes.MEMBERS_FETCH_NEXT_PAGE_SUCCESS,
            members: data.members,
            page: data.page,
          });
        }
      }
    });
  },
  loadFetchedMembersPage(page, url) {
    AppDispatcher.dispatch({
      type: ActionTypes.MEMBERS_FETCH_LOADED_PAGE,
      page,
    });

    this.loadFetchedMembers(page + 1, null, url, true); // nākamās lapas datus ielādēt
  },
};
